// @flow strict

import * as React from 'react'
import {
  USSignupForm,
  type PropsWithChildren,
} from '@mondough/public-web-components'
import { SectionWrapper, SectionThemes } from '../SectionWrapper'
import styles from './USAWaitlistSection.module.scss'

const USAWaitlistSection = ({ children }: PropsWithChildren<{}>) => (
  <SectionWrapper
    className={styles.section}
    theme={SectionThemes.BRAND}
    id="waitlist-signup"
  >
    {children}
    <div className={styles.formContainer}>
      <USSignupForm orientation="horizontal" />
    </div>
  </SectionWrapper>
)

export default USAWaitlistSection
